import React from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';

import actions from '@/actions';
import Select from '@/components/ui/kit/Select';
import { NotifierService as notifier } from '@/libs/Notifier';

const AddCommandSelect = () => {
  const store = useStore();
  const dispatch = useDispatch();
  const moveFromIndex = useSelector((state) => state.editor.moveFromIndex);
  const commands = useSelector((state) => state.mission.json.commands);
  const specs = useSelector((state) => state.mission.json.specs);

  const addCommand = (e) => {
    if (store.getState().map3d.isShow) {
      notifier.error('Commands cannot be added in 3D map.');
      return;
    }

    if (commands.length === 0) {
      notifier.error('Please add a takeoff point first.');
      return;
    }

    switch (specs.protocol) {
      case 'dji':
        addDJICommand(e.target.value);
        break;

      case 'mavlink':
        addMavLinkCommand(e.target.value);
        break;

      default:
        break;
    }
  };

  const addMavLinkCommand = (command) => {
    switch (command) {
      case 'autotuneEnable':
        dispatch(actions.mission.mavlink.appendAutotuneEnable());
        break;

      case 'changeAltitude':
        {
          const { altitude } = store.getState().editor.config;
          dispatch(actions.mission.mavlink.appendChangeAltitude(altitude));
        }
        break;

      case 'changeSpeed':
        {
          const { speed } = store.getState().editor.config;
          dispatch(actions.mission.mavlink.appendChangeSpeed(speed));
        }
        break;

      case 'cycleRelay':
        dispatch(actions.mission.mavlink.appendCycleRelay());
        break;

      case 'cycleServo':
        dispatch(actions.mission.mavlink.appendCycleServo());
        break;

      case 'delayUntil':
        dispatch(actions.mission.mavlink.appendDelayUntil());
        break;

      case 'gripper':
        dispatch(actions.mission.mavlink.appendGripper());
        break;

      case 'guidedEnable':
        dispatch(actions.mission.mavlink.appendGuidedEnable());
        break;

      case 'guidedLimits':
        dispatch(actions.mission.mavlink.appendGuidedLimits());
        break;

      case 'jumpToItem':
        dispatch(actions.mission.mavlink.appendJumpToItem());
        break;

      case 'returnToLaunch':
        dispatch(actions.mission.appendReturnToLaunch());
        break;

      case 'setRelay':
        dispatch(actions.mission.mavlink.appendSetRelay());
        break;

      case 'setRoiNone':
        dispatch(actions.mission.mavlink.appendSetRoiNone());
        break;

      case 'setServo':
        dispatch(actions.mission.mavlink.appendSetServo());
        break;

      case 'triggerParachute':
        dispatch(actions.mission.mavlink.appendTriggerParachute());
        break;

      case 'waitForDistance':
        dispatch(actions.mission.mavlink.appendWaitForDistance());
        break;

      case 'waitForYaw':
        dispatch(actions.mission.mavlink.appendWaitForYaw());
        break;

      default:
        break;
    }
  };

  const addDJICommand = (command) => {
    switch (command) {
      case 'returnToLaunch':
        dispatch(actions.mission.appendReturnToLaunch());
        break;

      default:
        break;
    }
  };

  if (specs.protocol === 'dji') {
    return (
      <Select onChange={addCommand} disabled={moveFromIndex !== null}>
        <option value="returnToLaunch">Return To Home</option>
      </Select>
    );
  }

  // mavlink
  return (
    <Select onChange={addCommand} disabled={moveFromIndex !== null}>
      {specs.firmware === 'ardupilot' && <option value="autotuneEnable">Autotune Enable</option>}
      <option value="setRoiNone">Cancel ROI</option>
      {specs.firmware === 'ardupilot' && <option value="changeAltitude">Change Altitude</option>}
      <option value="changeSpeed">Change Speed</option>
      {specs.firmware === 'ardupilot' && <option value="cycleRelay">Cycle Relay</option>}
      {specs.firmware === 'ardupilot' && <option value="cycleServo">Cycle Servo</option>}
      <option value="delayUntil">Delay Until</option>
      {specs.firmware === 'ardupilot' && <option value="gripper">Gripper</option>}
      {specs.firmware === 'ardupilot' && <option value="guidedEnable">Guided Enable</option>}
      {specs.firmware === 'ardupilot' && <option value="guidedLimits">Guided Limits</option>}
      <option value="jumpToItem">Jump To Item</option>
      <option value="returnToLaunch">Return To Launch</option>
      {specs.firmware === 'ardupilot' && <option value="setRelay">Set Relay</option>}
      <option value="setServo">Set Servo</option>
      {specs.firmware === 'ardupilot' && <option value="triggerParachute">Trigger Parachute</option>}
      {specs.firmware === 'ardupilot' && <option value="waitForDistance">Wait For Distance</option>}
      {specs.firmware === 'ardupilot' && <option value="waitForYaw">Wait For Yaw</option>}
    </Select>
  );
};

export default AddCommandSelect;
